<div class="workspace-layout">
  <!-- The banner is the first row of the layout, so it pushes the sidebar AND
       the main column down together. It used to overlay a fixed sidebar and
       clip its logo and first nav rows. -->
  @if(appNotificationService.current()){
  <tenant-top-banner
    [notification]="appNotificationService.current()!"
  ></tenant-top-banner>
  }

  <div class="workspace-body">
    <tenant-menu-left-nav
      (toggleMenu)="toggleSideMenu($event)"
      (collapsedChange)="sidebarCollapsed.set($event)"
      [isOpen]="isOpen"
      class="hidden lg:block"
    ></tenant-menu-left-nav>

    <main
      [class.sidebar-collapsed]="sidebarCollapsed()"
      class="main-content"
    >
      <tenant-workspace-header
        *ngIf="authUser()"
        [authUser]="authUser()!"
        [sidebarCollapsed]="sidebarCollapsed()"
        [onlineUsers]="onlineTenantUsers()"
        [tenantPresence]="tenantPresence"
        [unreadCount]="unreadCount"
        [envName]="envName"
        [envColor]="envColor"
        [onCompanyLogoClick]="navigateToSettings.bind(this)"
        [onLogout]="logout.bind(this)"
        [onMobileMenuOpen]="openMobileMenu"
        class="block"
      ></tenant-workspace-header>

      <div class="content-area">
        <div class="mb-2">
          <nz-breadcrumb *ngIf="breadcrumbs().length > 0" class="header-breadcrumbs">
            <nz-breadcrumb-item *ngFor="let crumb of breadcrumbs(); let last = last">
              <a *ngIf="!last && crumb.route" [routerLink]="crumb.route">{{ crumb.label }}</a>
              <span *ngIf="last || !crumb.route">{{ crumb.label }}</span>
            </nz-breadcrumb-item>
          </nz-breadcrumb>
        </div>

        <div
          [@fadeIn]="routeAnimation(outlet, animationNames.fadeIn)"
          [@slideFadeinRight]="
            routeAnimation(outlet, animationNames.slideFadeinRight)
          "
          [@slideFadeinUp]="routeAnimation(outlet, animationNames.slideFadeinUp)"
          [@zoomFadein]="routeAnimation(outlet, animationNames.zoomFadein)"
          class="z-20 theme-page-card-bg rounded-lg p-6 min-h-[calc(100vh-200px)] page-card"
        >
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </div>
    </main>
  </div>

  <nz-drawer
    (nzOnClose)="onDrawerClose()"
    (nzOnOpen)="onDrawerOpen()"
    [nzClosable]="true"
    [nzMaskClosable]="true"
    [nzTitle]="drawerTitleRef"
    [nzVisible]="visible"
    [nzWidth]="'min(320px, 85vw)'"
    nzPlacement="left"
  >
    <ng-template #drawerTitleRef>
      <div class="flex items-center justify-between w-full pr-8">
        <span class="text-base font-semibold">Menu</span>
        <button
          type="button"
          [nzDropdownMenu]="mobileThemeMenu"
          nz-dropdown
          [nzPlacement]="'bottomRight'"
          class="flex items-center justify-center w-9 h-9 rounded-lg transition-colors hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-1"
          [attr.aria-label]="'Theme: ' + themeService.getThemeModeLabel()"
        >
          <span class="fe text-lg {{ themeService.getThemeIconClass() }}"></span>
        </button>
      </div>
    </ng-template>
    <nz-dropdown-menu #mobileThemeMenu="nzDropdownMenu">
      <div class="theme-menu p-1 min-w-[210px]">
        <button type="button" class="theme-menu-item" (click)="themeService.setTheme('system')">
          <span class="fe fe-monitor mr-2"></span>
          <span>System (Recommended)</span>
          @if (themeService.themeMode() === 'system') {
            <span class="fe fe-check ml-auto"></span>
          }
        </button>
        <button type="button" class="theme-menu-item" (click)="themeService.setTheme('light')">
          <span class="fe fe-sun mr-2"></span>
          <span>Light</span>
          @if (themeService.themeMode() === 'light') {
            <span class="fe fe-check ml-auto"></span>
          }
        </button>
        <button type="button" class="theme-menu-item" (click)="themeService.setTheme('dark')">
          <span class="fe fe-moon mr-2"></span>
          <span>Dark</span>
          @if (themeService.themeMode() === 'dark') {
            <span class="fe fe-check ml-auto"></span>
          }
        </button>
      </div>
    </nz-dropdown-menu>
    <ng-container *nzDrawerContent>
      <div
        #drawerContentRef
        role="navigation"
        aria-label="Main menu"
        tabindex="-1"
        class="mobile-drawer-content"
      >
        <tenant-menu-left-nav
          [mobileDrawer]="true"
          [isOpen]="true"
          (collapsedChange)="noop()"
          (toggleMenu)="noop($event)"
          (logoutRequest)="logout()"
        ></tenant-menu-left-nav>
      </div>
    </ng-container>
  </nz-drawer>

  <!-- Command Palette -->
  <tenant-command-palette></tenant-command-palette>

  <!-- Connection Status Indicator -->
  @if (tenantNotificationService.connectionState() !== 'connected') {
  <div class="fixed bottom-4 right-4 bg-yellow-100 border-l-4 border-yellow-500 p-4 rounded shadow-lg z-50 max-w-sm">
    <div class="flex items-center">
      <span class="fe fe-alert-triangle text-yellow-500 mr-2"></span>
      <span class="text-sm">
        @switch (tenantNotificationService.connectionState()) {
          @case ('connecting') {
            Connecting to notifications...
          }
          @case ('disconnected') {
            Notifications disconnected.
            <button (click)="reconnectNotifications()" class="underline ml-2 text-blue-600 hover:text-blue-800">Reconnect</button>
          }
          @case ('failed') {
            Notifications failed to connect.
            <button (click)="reconnectNotifications()" class="underline ml-2 text-blue-600 hover:text-blue-800">Retry</button>
          }
        }
      </span>
    </div>
  </div>
  }
</div>

